import Constants from "./OurDoctorConstant";

let initialState = {
  doctorsDetails: [],
};

export default function DoctorReducer(state = initialState, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case Constants.ACTIONS.GET_ALL_DOCTORS_SUCCESS:
      newState.doctorsDetails = action.payload;
      break;
    default:
      break;
  }
  return newState;
}
